import script from "./ProYearlyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProYearlyCard.vue?vue&type=script&setup=true&lang=js"

import "./ProYearlyCard.vue?vue&type=style&index=0&id=cd1240bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd1240bc"]])

export default __exports__